/**
 * Hand signed gateway parameters to PayU, on whichever platform we are.
 *
 * In a browser this is what it has always been: fill a hidden form and submit
 * it, so the parameters travel as a real cross-origin POST.
 *
 * In the desktop app that submit goes nowhere — Electron treats an off-origin
 * navigation as something to block, and the usual fallback (open it in the
 * system browser) can only perform a GET, which drops the signed parameters and
 * lands the user on a gateway error. So desktop routes the same POST into a
 * dedicated payment window instead. Every payment flow in the product —
 * wallet top-up, plan purchase, photo-frame order, payment link — goes through
 * here so none of them can drift apart again.
 */
export default function submitPaymentForm(form, url, params) {
	if (window.photentra?.openPaymentWindow) {
		window.photentra.openPaymentWindow({ url, params });
		return;
	}

	if (!form) return;
	form.action = url;
	form.method = "POST";
	while (form.firstChild) form.removeChild(form.firstChild);
	Object.entries(params || {}).forEach(([key, value]) => {
		const input = document.createElement("input");
		input.type = "hidden";
		input.name = key;
		input.value = value == null ? "" : value;
		form.appendChild(input);
	});
	form.submit();
}
